import React, { useState, useEffect } from 'react';
import riddles from './Riddles';
import './Riddle.css';

const Riddle = () => {
  const [currentRiddleIndex, setCurrentRiddleIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60);
  const [showAnswer, setShowAnswer] = useState(false);

  useEffect(() => {
    if (timeLeft > 0 && !showAnswer) {
      const timerId = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timerId);
    } else if (timeLeft === 0) {
      setShowAnswer(true);
      const msg = new SpeechSynthesisUtterance(riddles[currentRiddleIndex].answer);
      msg.lang = 'te-IN';
      window.speechSynthesis.speak(msg);
    }
  }, [timeLeft, showAnswer]);

  const handleReadQuestion = () => {
    const msg = new SpeechSynthesisUtterance(riddles[currentRiddleIndex].question);
    msg.lang = 'te-IN';
    window.speechSynthesis.speak(msg);
  };

  const handleNextRiddle = () => {
    let randomIndex;
    do {
      randomIndex = Math.floor(Math.random() * riddles.length);
    } while (randomIndex === currentRiddleIndex); // Ensure the next riddle is not the same as the current one
    setCurrentRiddleIndex(randomIndex);
    setTimeLeft(60);
    setShowAnswer(false);
  };

  return (
    <div className="riddle-container">
      <h1>క్విజ్</h1>
      <p>{riddles[currentRiddleIndex].question}</p>
      <button onClick={handleReadQuestion}>ప్రశ్న చదవండి</button>
      <p>సమయం: {timeLeft}</p>
      {showAnswer && <p>సమాధానం: {riddles[currentRiddleIndex].answer}</p>}
      {showAnswer && <button onClick={handleNextRiddle}>తర్వాతి ప్రశ్న</button>}
    </div>
  );
};

export default Riddle;
